import React from "react";

const Button = ({ title, onClick, type, link, classes, allClasses }) => {
  return type === "link" ? (
    <a target="_blank" rel="noreferrer" href={link}>
      <button
        className={
          allClasses
            ? allClasses
            : `items-center justify-center text-[17px] bg-[#0E8A28] h-[55px] w-[166px] text-[#FFF] font-[500] ${classes} `
        }
      >
        {title}
      </button>
    </a>
  ) : (
    <button
      onClick={onClick}
      className={`items-center justify-center text-[17px] bg-[#0E8A28] h-[55px] w-[166px] text-[#FFF] font-[500] ${classes} `}
    >
      {title}
    </button>
  );
};

export default Button;
